import styled from 'styled-components'

export const defaultMainCardStyles = `
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 1rem;`

export const GoalsContainer = styled.div`
  background: ${({ theme, themeType }) => theme?.[themeType]?.bgDashboardGoals};
  ${defaultMainCardStyles}
  box-shadow: 0 4px 24px rgba(34, 86, 200, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
  padding: 1rem 1rem 1.5rem;

  @media (min-width: 480px) {
    padding: 1.25rem 1.5rem;
  }
  @media (min-width: 768px) {
    padding: 2rem;
    border-radius: 1.25rem;
    box-shadow: 0 8px 40px rgba(34, 86, 200, 0.28);
  }
`
export const MembersContainer = styled.div`
  background: ${(props) => (props.theme === 'dark' ? ' #25262a' : 'transparent')};
  ${defaultMainCardStyles}
`
export const GoalsCarouselContainer = styled.div`
  padding: 32px 0 24px 0;
  overflow: visible;

  @media (min-width: 768px) {
    padding: 40px 0 28px 0;
  }
`

// OG:

export const OGSeparator = styled.hr``
